import { Share2, Link as LinkIcon, X } from "lucide-react";
import { OverlayButton } from "./ReportOverlayButton";

const BG = { share: "linear-gradient(180deg,#22c55e,#15803d)",
  copy: "linear-gradient(180deg,#f59e0b,#b45309)", close: "linear-gradient(180deg,#f43f5e,#9f1239)" };

// تخطيط ثابت: «مشاركة» و«نسخ الرابط» بنصفين متساويين من البداية، و«إغلاق» في صفّه السفلي.
// الزرّان يظهران بلونهما الطبيعي فوراً؛ وجهوزية الرابط تُدار داخل onCopy دون أي تأثير باهت.
export const ReportOverlayBar = ({ m, hasHtml, onShare, onCopy, onClose }) => (
  <div style={{ padding: "8px 10px", background: "#eef1f6", boxShadow: "0 -2px 10px rgba(0,0,0,.08)" }}>
    <div style={{ display: "flex", gap: 8 }}>
      {hasHtml && (
        <OverlayButton testid="overlay-share" background={BG.share} onClick={onShare}>
          <Share2 size={16} />{m.share}</OverlayButton>
      )}
      <OverlayButton testid="overlay-copy" background={BG.copy} onClick={onCopy}>
        <LinkIcon size={16} />{m.copy}</OverlayButton>
    </div>
    <div style={{ display: "flex", marginTop: 8 }}>
      <OverlayButton testid="overlay-close" background={BG.close} onClick={onClose}>
        <X size={16} />{m.close}</OverlayButton>
    </div>
  </div>
);
